import {
  HStack,
  Text,
  IconButton,
  Tooltip,
  Flex,
  Box,
  Button,
} from "@chakra-ui/react";
import AddIcon from "@root/assets/icons/addicon";
import DeleteIcon from "@root/assets/icons/deleteicon";
import FileDropdown from "@root/components/checklist/Filesdropdown";
import { useTranslation } from "react-i18next";
import {
  DeleteIconContainer,
  DocumentStack,
  LabelContainer,
} from "@root/components/dashboard/style";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { PDFIcon } from "@root/assets/icons/PDFIcon";

const addLabelsAndColors = (originalArray: any) => {
  const colorSchemes = ["red", "cyan", "purple"];
  return originalArray?.map((obj: any, index: number) => ({
    ...obj,
    label: String.fromCharCode(65 + index), // 65 is ASCII for 'A'
    colorScheme: colorSchemes[index % colorSchemes.length],
  }));
};

const DocumentHeader: React.FC<any> = () => {
  const [hoveredItem, setHoveredItem] = useState<any>(null);
  const {t}=useTranslation("common")
  const {
    attachedFile,
    setAttachedFile,
    downloadPdfOfThread,
    downloadPdfLoading,
  } = useMainChatContext();
  const documents = addLabelsAndColors(attachedFile);
  const { id } = useParams();

  const handleDelete = (id: string) => {
    setAttachedFile((prev: any) => prev.filter((doc: any) => doc.id !== id));
  };

  return (
    <HStack
      bg={"#F0F2F7"}
      p={"10px 25px"}
      justifyContent={"space-between"}
      position="relative"
      spacing={5}
      overflow="visible"
    >
      <HStack overflowX="auto">
        {documents?.map((doc: any) => (
          <Flex
            key={doc.id}
            position="relative"
            gap={"8px"}
            cursor={"pointer"}
            _hover={{ bgColor: "white" }}
            p={"7px 12px"}
            borderRadius={"md"}
            onMouseEnter={() => setHoveredItem(doc)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <DocumentStack>
              <LabelContainer
                color={`${doc.colorScheme}.400`}
                borderColor={`${doc.colorScheme}.400`}
              >
                {doc?.label}
              </LabelContainer>
              <Text fontSize="sm" whiteSpace="nowrap">
                {doc?.fileName}
              </Text>
            </DocumentStack>

            {doc?.id === hoveredItem?.id && (
              <DeleteIconContainer alignSelf={"center"}>
                <Tooltip label="Delete" hasArrow>
                  <IconButton
                    icon={<DeleteIcon boxSize={5} />}
                    size="xs"
                    aria-label="Delete"
                    variant="ghost"
                    colorScheme="red"
                    onClick={() => handleDelete(doc.id)}
                  />
                </Tooltip>
              </DeleteIconContainer>
            )}
          </Flex>
        ))}
      </HStack>
      {id && (
        <Button
          border={"1px solid #FF1607"}
          bgColor={"white"}
          color={"#FF1607"}
          fontWeight={400}
          height={"42px"}
          onClick={() => downloadPdfOfThread({ threadId: id })}
          isLoading={downloadPdfLoading}
        >
          <PDFIcon mr={"7px"} />
          {t("translate.downloadPdf")}
        </Button>
      )}
    </HStack>
  );
};

export default DocumentHeader;
